import React, { useState, useEffect } from "react";
import { fetchSamples } from "../sample_reporting/Utils/SamplesFetch";
import { fetchJson, post } from "../../lib/Fetching";

const findSampleIds = (trayId) => {
  return fetchJson("/trays/trays/" + trayId + "/sample_ids", {});
};

const findActiveTrayForItem = (itemId) => {
  return fetchJson("/trays/trays/active_tray_for_item.json", { item_id: itemId });
};

const findSamples = async (trayId) => {
  const json = await findSampleIds(trayId);

  if (!json.sample_ids || json.sample_ids.length == 0)
    return Promise.resolve({
      samples: [],
      columns: [],
    });

  return fetchSamples({
    sample_ids: json.sample_ids,
    show_all_samples: true,
  });
};

export { findSamples, findActiveTrayForItem };
